import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { plusIcon, saveIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useEffect, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";
import { Checkbox, Switch, TextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ListView, ListViewHeader, ListViewItemProps } from "@progress/kendo-react-listview";

export const RegistryAccounts = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(false);
    const [errorMessage, setErrorMessage] = useState<any>(false);
    const [messageSentEmail, setMessageSentEmail] = useState<any>('');


    const [accountsList, setAccountsList] = useState<any>([]);

    const [messageDeletedAccount, setMessageDeletedAccount] = useState<boolean>(false);
    const [messageSavedAccount, setMessageSavedAccount] = useState<boolean>(false);
    const [messageClonedAccount, setMessageClonedAccount] = useState<boolean>(false);
    const [messageUpdatedAccount, setMessageUpdatedAccount] = useState<boolean>(false);

    const [accountPhone, setAccountPhone] = useState<any>('');
    const [accountEmail, setAccountEmail] = useState<any>('');

    const [updateAccount, setUpdateAccount] = useState<boolean>(false);

    const [switchUserType, setSwitchUserType] = useState<boolean>(true);
    const [features, setFeatures] = useState({
        loc: false,
        syn: false,
    });
    const [accountIsNotVerified, setAccountIsNotVerified] = useState<any>('');
    const [disableEmail, setDisableEmail] = useState<any>(false);
    const [disableType, setDisableType] = useState<any>(false);

    const accountTypeList: any = {
        "data": [
            {
                "id": -1,
                "name": localizationService.toLanguageString('configuration.registry.account.type.select_value', 'NOT FOUND'),
                "type": localizationService.toLanguageString('configuration.registry.account.type.select_value', 'NOT FOUND')
            },
            {
                "id": 0,
                "name": localizationService.toLanguageString('configuration.registry.account.type.ubiquicomAdmin', 'NOT FOUND'),
                "type": "UbiquicomAdmin"
            },
            {
                "id": 1,
                "name": localizationService.toLanguageString('configuration.registry.account.type.userAdmin', 'NOT FOUND'),
                "type": "UserAdmin"
            },
            {
                "id": 2,
                "name": localizationService.toLanguageString('configuration.registry.account.type.standard', 'NOT FOUND'),
                "type": "Standard"
            }
        ]
    }

    const [accountTypeId, setAccountTypeId] = useState<any>('');
    const [accountTypeName, setAccountTypeName] = useState<any>(accountTypeList.data[0].type);
    const [accountTypeDescription, setAccountTypeDescription] = useState<any>('');

    const [accountInfo, setAccountInfo] = useState<any>([
        {
            'id': -1,
            'email': '',
            'phone': '',
            'type': 0,
            'features': {}
        }
    ]);

    const accountType = localStorage.getItem('userType');
    const hideSynFeature = accountType === 'UbiquicomAdminOnlyLocator'
        || accountType === 'UserAdminOnlyLocator'
        || accountType === 'StandardOnlyLocator';
    const hideLocFeature = accountType === 'StandardOnlySyncro';
    const isAdminAccountType = accountTypeName === 'UbiquicomAdmin' || accountTypeName === 'UserAdmin';
    const isStandardAccountType = accountTypeName === 'Standard';

    useEffect(() => {
        getAccountList();
    }, []);

    useEffect(() => {
        setFeatures((prev) => {
            const next = {
                ...prev,
                loc: hideLocFeature ? false : prev.loc,
                syn: hideSynFeature ? false : prev.syn,
            };

            if (isAdminAccountType && !hideLocFeature) {
                next.loc = true;
            }

            if (isStandardAccountType && !next.loc && !next.syn) {
                if (!hideLocFeature) {
                    next.loc = true;
                } else if (!hideSynFeature) {
                    next.syn = true;
                }
            }

            if (next.loc === prev.loc && next.syn === prev.syn) {
                return prev;
            }

            return next;
        });
    }, [hideLocFeature, hideSynFeature, isAdminAccountType, isStandardAccountType]);

    const getAccountList = async () => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/account`, { headers })
                .then((res) => {
                    if (res?.data?.data?.length == 0) {
                        setLoading(false);
                        return;
                    }

                    const data = res?.data?.data

                    let accountList: any = []
                    data.forEach((account: any) => {
                        if (account.id != -1)
                            accountList.push(account)
                    });

                    setAccountsList(accountList);
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    };

    const handleChangeAccountPhone = (event: any) => {
        const rawPhone: string = event?.target?.value ?? '';
        const currentPhone = rawPhone.replace(/[^0-9+;/-]/g, '');
        setAccountPhone(currentPhone)

        setAccountInfo((prev: any) => [
            {
                ...prev[0],       // copia tutte le proprietà del primo oggetto
                phone: currentPhone // sovrascrivi solo email
            },
            ...prev.slice(1)   // mantieni gli altri elementi dell'array
        ]);
    }

    const validateEmail = (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleChangeAccountEmail = (event: any) => {
        let currentEmail: any = event.value
        setAccountEmail(currentEmail)

        setAccountInfo((prev: any) => [
            {
                ...prev[0],       // copia tutte le proprietà del primo oggetto
                email: currentEmail // sovrascrivi solo email
            },
            ...prev.slice(1)   // mantieni gli altri elementi dell'array
        ]);
    }

    const getSelectedAccount = (Account: any) => {
        setAccountInfo([
            {
                'id': Account.id,
                'email': Account.email,
                'phone': Account.phoneNumber,
                'userType': Account.role,
                'isLocal': Account.isLocal,
                'features': Account.features
            }
        ]);

        setAccountEmail(Account.email);
        setAccountPhone(Account.phone);
        setAccountTypeName(Account.role);
        setSwitchUserType(Account.isLocal)
        setFeatures({
            loc: Account.features[0],
            syn: Account.features[1]
        });
        setAccountIsNotVerified(Account.isNotVerified)
        setDisableEmail(true)
        setDisableType(true)
        setUpdateAccount(true);
    }

    const updateSelectedAccount = async (accountInfo: any) => {

        setLoading(true);

        const accountId:any = accountInfo.id

        let featuresList: any = []

        accountInfo.features.forEach((value:any) => {
            featuresList.push(value)
        })

        const params = {
            phoneNumber: accountInfo.phone ?? '',
            type: accountTypeName,
            features: Object.values(featuresList)
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            try {
                await axios.put(`${SERVER_URL}/Account/${accountId}`, params, { headers })
                
                setUpdateAccount(false)
                getAccountList();

                setLoading(false)
                setMessageUpdatedAccount(true);
                if (!messageUpdatedAccount) {
                    setTimeout(() => {
                        setMessageUpdatedAccount(false);
                    }, 3000);
                }

            } catch (error: any) {
                setErrorMessage(error?.response?.data?.errorMessage)
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }


    }

    const saveNewAccount = async (currAccountInfo: any) => {


        if (!currAccountInfo[0].email) {
            setErrorMessage(localizationService.toLanguageString('configuration.registry.account.validation.required', 'NOT FOUND'));
            return
        } else if (!validateEmail(currAccountInfo[0].email)) {
            setErrorMessage(localizationService.toLanguageString('configuration.registry.account.validation.email', 'NOT FOUND'));
            setTimeout(() => {
                setErrorMessage('');
            }, 3000);
            return
        } else {
            setAccountInfo((prev: any) => [
                {
                    ...prev[0],       // copia tutte le proprietà del primo oggetto
                    email: currAccountInfo[0].email // sovrascrivi solo email
                },
                ...prev.slice(1)   // mantieni gli altri elementi dell'array
            ]);
        }

       

        setLoading(true);

        let featuresList: any = []

        for (const [key, value] of Object.entries(features)) {
            if (value === true) {
                featuresList.push(key)
            }
        }

        let currAccount: any = [
            {
                'phoneNumber': currAccountInfo[0].phone,
                'email': currAccountInfo[0].email,
                'role': accountTypeName,
                'isLocal': switchUserType,
                'features': Object.values(featuresList)
            }
        ];

        if (accountsList.length > 0 && currAccountInfo[0].name != '') {
            if (accountsList.some((e: any) => e.name === currAccountInfo[0].name) || currAccountInfo.length == 0) {
            } else {
                setAccountsList([...accountsList, currAccount[0]]);
            }

        } else {
            setAccountsList([...accountsList, currAccountInfo]);
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                email: currAccount[0].email,
                phoneNumber: currAccount[0].phoneNumber ?? '',
                role: currAccount[0].role,
                isLocal: currAccount[0].isLocal,
                features: currAccount[0].features
            };
            try {
                await axios.post(`${SERVER_URL}/Account`, params, { headers })
                setAccountEmail('');
                setAccountPhone('');

                setLoading(false)

                getAccountList();

                setMessageSavedAccount(true);
                if (!messageSavedAccount) {
                    setTimeout(() => {
                        setMessageSavedAccount(false);
                    }, 3000);
                }
            } catch (error: any) {
                const responseMessage = error?.response?.data?.errorMessage;
                if(responseMessage.toLowerCase().includes('email already exists')) {
                    setErrorMessage(localizationService.toLanguageString('configuration.registry.account.validation.email_exists', 'NOT FOUND'));
                } else {
                    setErrorMessage(localizationService.toLanguageString('configuration.registry.account.with_device_error', 'NOT FOUND'));
                }
                if (error.response.data.errorMessage) {
                    setTimeout(() => {
                        setErrorMessage('');
                    }, 3000);
                }
                setLoading(false)
            }            
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const removeNewAccount = async (accountId: any, index: any) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.delete(`${SERVER_URL}/Account/${accountId}`, { headers }),
                    setAccountsList((oldValues: any) => {
                        return oldValues.filter((_: any, i: any) => i !== index)
                    })

                setLoading(false)
                setMessageDeletedAccount(true)
            } catch (error: any) {
                setErrorMessage(error.response.data.errorMessage);
                if (error.response.data.errorMessage) {
                    setTimeout(() => {
                        setErrorMessage('');
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

        if (!messageDeletedAccount || !error) {
            setTimeout(() => {
                setMessageDeletedAccount(false);
                setError(false);
            }, 3000);
        }
    }

    const refreshAccount = () => {
        setAccountEmail('');
        setAccountPhone('');
        setAccountTypeName('');
        setSwitchUserType(true);
        setFeatures({ loc: false, syn: false });
        setAccountInfo([]);
        setUpdateAccount(false);
        setDisableEmail(false)
        setDisableType(false)
    }

    const handleToggleSwitchType = (e: any) => {
        setSwitchUserType(e.value);
    }

    const handleToggleSwitchFeature = (e: any, key: "loc" | "syn") => {
        setFeatures(prev => {
            const next = {
                ...prev,
                [key]: e.value
            };

            if (hideLocFeature) {
                next.loc = false;
            }

            if (hideSynFeature) {
                next.syn = false;
            }

            if (isAdminAccountType && !hideLocFeature) {
                next.loc = true;
            }

            if (isStandardAccountType && !next.loc && !next.syn) {
                if (!hideLocFeature) {
                    next.loc = true;
                } else if (!hideSynFeature) {
                    next.syn = true;
                }
            }

            return next;
        });
    };

    const UsersRender = (props: ListViewItemProps) => {
        let account = props.dataItem;
        const storedAccountId = localStorage.getItem('accountId');
        const isCurrentAccount = storedAccountId != null && account?.id?.toString() === storedAccountId;
        const deleteDisabled = isCurrentAccount;
        return (
            <div
                className="k-listview-item row p-2 border-bottom align-middle"
                style={{
                    margin: 0,
                    pointerEvents: isCurrentAccount ? 'none' : 'auto'
                }}
            >
                <div
                    className="trash-icon"
                    title={localizationService.toLanguageString('configuration.registry.account.delete', 'NOT_FOUND')}
                    style={{
                        float: 'left',
                        cursor: deleteDisabled ? 'not-allowed' : 'pointer',
                        alignContent: 'center',
                        opacity: deleteDisabled ? 0.5 : 1,
                        pointerEvents: deleteDisabled ? 'none' : 'auto'
                    }}
                    onClick={() => {
                        setUpdateAccount(false)
                        removeNewAccount(account.id, props.index)
                    }}
                >
                    <Avatar
                        className="trash-icon"
                    >
                        <SvgIcon
                            icon={trashIcon}
                            style={{ verticalAlign: 'baseline', margin: '10px' }}
                        />
                    </Avatar>
                </div>

                <div
                    className="col-10"
                    style={{
                        cursor: isCurrentAccount ? 'default' : 'pointer',
                        color: isCurrentAccount ? '#7f9da3' : '#018CA5',
                        alignContent: 'center',
                        pointerEvents: isCurrentAccount ? 'none' : 'auto'
                    }}
                    onClick={() => { getSelectedAccount(account) }}
                >
                    <h2
                        style={{
                            fontSize: 16,
                            cursor: isCurrentAccount ? 'default' : 'pointer',
                            padding: '10px',
                            whiteSpace: 'nowrap',
                            display: 'inline'
                        }}
                    >
                        {account.email}
                    </h2>
                </div>
            </div>
        );
    };

    const MyHeader = () => {
        return (
            <>
                <ListViewHeader
                    style={{ display: 'flex', margin: '0px auto', color: "#018CA5", fontSize: 14 }}
                    className="pl-3 pb-2 pt-2"
                >
                    <p style={{ fontSize: '20px', color: '#1A8893', }}>{localizationService.toLanguageString('configuration.registry.account.title', 'NOT_FOUND')} ({accountsList.length})</p>

                    <div
                        className="plusParam"
                        title={localizationService.toLanguageString('configuration.registry.account.new', 'NOT_FOUND')}
                        style={{
                            marginLeft: '10px'
                        }}
                        onClick={refreshAccount}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </div>
                </ListViewHeader>
            </>
        );
    };


    const resendToken = async (accountInfo: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            try {
                await axios.post(`${SERVER_URL}/Account/resend-email-registration/${accountInfo.id}`, { headers })

                setLoading(false)

                setMessageSentEmail(true);
                if (!messageSentEmail) {
                    setTimeout(() => {
                        setMessageSentEmail(false);
                    }, 5000);
                }
            } catch (error: any) {
                setErrorMessage(error.message);
                if (error.message) {
                    setTimeout(() => {
                        setErrorMessage('');
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    return (
        <div className="flex-parent-element" style={{ overflowX: 'hidden' }}>
            {loading && loadingPanel}
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 0,
                    position: "absolute",
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {messageDeletedAccount && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            onClose={() => setMessageDeletedAccount(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.account.deleted', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {messageSavedAccount && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            onClose={() => setMessageSavedAccount(false)}
                        >
                            <span>
                                { switchUserType ? 
                                    localizationService.toLanguageString('configuration.registry.account.saved', 'NOT FOUND') 
                                    : 
                                    localizationService.toLanguageString('configuration.registry.account.savedSSO', 'NOT FOUND') 
                                }
                            </span>
                        </Notification>
                    )}
                    {messageClonedAccount && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            onClose={() => setMessageClonedAccount(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.account.cloned', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {messageUpdatedAccount && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            onClose={() => setMessageUpdatedAccount(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.account.updated', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {messageSentEmail && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            onClose={() => setMessageSentEmail(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.account.sent-message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {error || errorMessage && (
                        <Notification
                            type={{ style: "error", icon: true }}
                            onClose={() => setError(false)}
                        >
                            {
                                errorMessage
                                    ?
                                    <span>{errorMessage}</span>
                                    :
                                    <span>{localizationService.toLanguageString('configuration.registry.account.with_device_error', 'NOT FOUND')}</span>
                            }
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>

            <div
                style={{
                    //display: 'inline-table', 
                    padding: '20px',
                    backgroundColor: '#f7f7f7',
                    overflowY: 'auto'
                }}
            >
                <ListView
                    data={accountsList}
                    item={UsersRender}
                    style={{ background: "#F7F7F7" }}
                    header={MyHeader}
                />
            </div>


            <div
                className="flex-right-child-element"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: 'white',
                    flexGrow: 3,
                    gap: '10px',
                    alignItems: 'center',
                    paddingLeft: '0px'
                }}
            >

                <div style={{ display: 'flex', marginLeft: '50px' }}>

                    {/*email*/}
                    <p style={{ color: '#1A8893', margin: '10px' }}>{localizationService.toLanguageString('configuration.registry.account.email', 'NOT_FOUND')}</p>
                    <TextBox
                        style={{ width: "350px", marginRight: '15px' }}
                        value={accountEmail == "" ? accountEmail : accountInfo?.map((account: any) => {
                            return account.email
                        })}
                        onChange={handleChangeAccountEmail}
                        placeholder=''
                        disabled = {disableEmail}
                    />
                    <br />

                    {/*save / update*/}
                    {!updateAccount ?
                        <Button
                            title={localizationService.toLanguageString('configuration.registry.account.save', 'NOT FOUND')}
                            themeColor={"primary"}
                            className="saveParam"
                            disabled={(accountEmail && (features?.loc || features?.syn)) == '' ? true : false}
                            onClick={() => saveNewAccount(accountInfo)}
                        >
                            <Avatar
                                className="saveParam"
                            >
                                <SvgIcon
                                    icon={saveIcon}
                                    style={{ margin: '8px' }}
                                />
                            </Avatar>
                        </Button>
                        :
                        <div>

                            <Button
                                title={localizationService.toLanguageString('configuration.registry.account.update', 'NOT FOUND')}
                                themeColor={"primary"}
                                className="saveParam"
                                onClick={() => updateSelectedAccount(accountInfo[0])}
                            >
                                <Avatar
                                    className="saveParam"
                                >
                                    <SvgIcon
                                        icon={saveIcon}
                                        style={{ margin: '8px' }}
                                    />
                                </Avatar>
                            </Button>
                        </div>
                    }
                </div>

                {/*phone*/}
                <div style={{ display: 'flex' }}>
                    <p style={{ color: '#1A8893', margin: '10px' }}>{localizationService.toLanguageString('configuration.registry.account.phone', 'NOT_FOUND')}</p>
                    <TextBox
                        style={{ width: "350px", marginRight: `${languageId == 'it-IT' ? '30px' : '15px'}` }}
                        value={accountPhone == "" ? accountPhone : accountInfo?.map((account: any) => {
                            return account.phone
                        })}
                        onChange={handleChangeAccountPhone}
                        placeholder=''
                    />
                </div>

                {/*account role*/}
                <div style={{ display: 'flex' }}>
                    <p style={{ color: '#1A8893', margin: '10px' }}>
                        {localizationService.toLanguageString('configuration.registry.account.type.rule', 'NOT FOUND')}
                    </p>
                    <DropDownList
                        style={{ width: "350px", height: "45px", marginRight: `${languageId == 'it-IT' ? '10px' : '0px'}` }}
                        textField={'name'}
                        dataItemKey={'id'}
                        data={(accountType === "UserAdminOnlyLocator" || accountType === "UserAdmin") ? accountTypeList.data.filter((item: any) => (item.id !== 0 )) : accountTypeList.data}
                        value={
                            accountTypeList.data.find((item: any) => item.type === accountTypeName) ?? accountTypeList.data[0]
                        }
                        onChange={(e: any) => {
                            setAccountTypeId(e.value.id)
                            setAccountTypeName(e.value.type)
                            setAccountTypeDescription(e.value.description)
                        }}
                    />
                </div>

                {/*account type*/}
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <p style={{ color: '#1A8893' }}>
                        {localizationService.toLanguageString('configuration.registry.account.type.type', 'NOT_FOUND')}
                    </p>
                    <div style={{ 
                            display: 'flex', 
                            flexDirection: 'row', 
                            width: `${languageId == 'it-IT' ? '350px' : '350px'}`, 
                            alignItems: 'anchor-center',
                            opacity: disableType ? 0.5 : 1
                        }}>
                        <Switch
                            className={'k-switch registry-account'}
                            onChange={handleToggleSwitchType}
                            checked={switchUserType}
                            disabled={disableType}
                        />
                        <p style={{ marginBottom: '0px' }}>
                            {switchUserType ?
                                localizationService.toLanguageString('configuration.registry.account.type.local', 'NOT_FOUND')
                                :
                                localizationService.toLanguageString('configuration.registry.account.type.domain', 'NOT_FOUND')
                            }
                        </p>
                    </div>

                </div>

                {/*features*/}
                <div style={{ display: 'flex' }}>
                    <p style={{ color: '#1A8893', marginBottom: '3px', marginRight: '10px' }}>
                        {localizationService.toLanguageString('configuration.registry.account.type.feature', 'NOT_FOUND')}
                    </p>
                    <div style={{ width: `${languageId == 'it-IT' ? '405px' : '360px'}` }}>
                        {!hideLocFeature && (
                            <Checkbox
                                checked={features.loc}
                                onChange={(e) => handleToggleSwitchFeature(e, "loc")}
                                label={localizationService.toLanguageString('configuration.registry.account.type.locator', 'NOT_FOUND')}
                                disabled={isAdminAccountType}
                            />
                        )}
                        {!hideSynFeature && (
                            <Checkbox
                                checked={features.syn}
                                onChange={(e) => handleToggleSwitchFeature(e, "syn")}
                                label={localizationService.toLanguageString('configuration.registry.account.type.synchro', 'NOT_FOUND')}
                            />
                        )}
                    </div>
                </div>

                {accountIsNotVerified && switchUserType &&
                    <p
                        className="resend-token"
                        onClick={() => resendToken(accountInfo[0])}
                    >
                        {localizationService.toLanguageString('configuration.registry.account.resend-token', 'NOT FOUND')}
                    </p>
                }

            </div>
        </div>
    );


};